const ga = (...args) => {
  if (typeof window !== 'undefined') {
    window.ga(...args)
  }
}

export default ga



// WEBPACK FOOTER //
// ./common/utils/ga.js